<template>
  <div class="physicians-results">
    <template v-if="store.queryStatus == 'loading'">
      <div class="d-flex justify-content-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </template>
    <template v-if="store.queryStatus == 'ready'">
      <template v-if="store.physicians.length > 0">
        <div class="fw-bold mb-3">
          {{ store.totalNumberOfResults }} {{ resultsFoundLabel }}. {{ showingResultsLabel }} {{ store.query.resultsPerPage * (store.query.pageNumber - 1) + 1 }} - {{ Math.min(store.query.resultsPerPage * store.query.pageNumber, store.totalNumberOfResults) }}:
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 mb-5" v-for="physician in store.physicians">
            <div class="physician-result-item" v-if="physician.firstName && physician.lastName">
              <img class="physician-result-image" :src="physician.image ? physician.image : defaultImage" alt="">
              <div class="fw-bold mb-2">
                {{ physician.firstName }} {{physician.middleInitial}} {{ physician.lastName }}{{ physician.degree ? `, ${physician.degree}` : '' }}
              </div>
              <div class="mb-2">
                {{ physician.subspecialties ? physician.subspecialties : physician.specialties }}
              </div>
              <div class="d-flex flex-wrap align-items-center gap-2 mb-2" v-if="physician.showProfile || physician.epicUrl">
                <a
                  v-if="physician.showProfile"
                  class="btn btn-secondary stretched-link"
                  :href="physician.url"
                  :aria-label="`${viewProfileLabel} ${physician.firstName} ${physician.lastName}`"
                >
                  {{ viewProfileLabel }}
                </a>
                <a
                  v-if="physician.epicUrl"
                  class="btn btn-schedule-online physician-result-schedule-online ms-auto"
                  :href="physician.epicUrl"
                  target="_blank"
                  rel="noopener"
                  :aria-label="`${scheduleOnlineLabel} ${physician.firstName} ${physician.lastName}`"
                >
                  {{ scheduleOnlineLabel }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="store.physicians.length === 0">
        <div class="h5 fw-bold">
          {{ noResultsLabel }}
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { ChpPhysiciansStore } from '../stores/ChpPhysiciansStore'

export default {
  props: {
    defaultImage: {
      type: String,
      required: true
    },
    viewProfileLabel: {
      type: String,
      required: true
    },
    scheduleOnlineLabel: {
      type: String,
      required: true
    },
    noResultsLabel: {
      type: String,
      required: true
    },
    resultsFoundLabel: {
      type: String,
      required: true
    },
    showingResultsLabel: {
      type: String,
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  setup() {
    const store = ChpPhysiciansStore()
    store.updateQueryFromUrlParameters()
    store.getResultsFromQuery()
    return {
      store
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
  components: {
  }
}
</script>
